import { Color } from '@common/types/radix';
import { Badge } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { Clip, ClipMediaObjectType } from '..';

interface MediaObjectTypeBadgeProps {
    clip: Clip;
}

const MEDIA_TYPE_COLORS: Record<ClipMediaObjectType, Color> = {
    VIDEO: 'indigo',
    AUDIO: 'crimson',
    IMAGE: 'amber',
    DOCUMENT: 'grass',
    PACKAGE: 'gray',
    // AUDIO: 'grass',
    // VIDEO: 'blue',
    // IMAGE: 'amber',
    // PACKAGE: 'crimson',
    // DOCUMENT: 'cyan',
};

const formatType = (type: string) => {
    if (!type) return '';
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
};

export const MediaObjectTypeBadge = ({ clip }: MediaObjectTypeBadgeProps) => {
    const { t } = useTranslation('clipTable');

    if (!clip) return null;

    const { mediaObjectType } = clip;

    return (
        <Badge
            variant='solid'
            radius={'large'}
            color={MEDIA_TYPE_COLORS[mediaObjectType]}
            style={{ padding: '2px var(--space-2)' }}
        >
            {formatType(t(mediaObjectType))}
        </Badge>
    );
};
